import React, { useEffect, useState } from "react";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Header from "../Common/Header";
import { useNavigate } from "react-router-dom";
import { pageSlug } from "../../../../Constants/AppConstants";
import { useDispatch } from "react-redux";
import { getPageWithSlugAPI } from "../../../../Store/Action/page";
import Footer from "../../Layout/Footer/Footer";
import { Helmet } from "react-helmet-async";
const WelcomeScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [partnersData, setPartnersData] = useState([]);
  const [benifitsMember, setBenefitsMember] = useState([]);

  const onBecomeManufacture = () => {
    navigate("/inquiry-form");
  };
  const onBecomeRetailer = () => {
    navigate("/login");
  };
  useEffect(() => {
    dispatch(
      getPageWithSlugAPI(pageSlug.partners, (result) => {
        setPartnersData(result?.[0]?.page_json?.[0]?.page_partner_data);
        setBenefitsMember(result?.[0]?.page_json?.[0]?.page_partner_benefits);
      }),
    );
  }, [dispatch]);
  return (
    <>
      <Helmet>
        <title>
          Zabali - Buy Premium Jewelry Online | Direct Manufacturer Wholesale
          Marketplace
        </title>

        <meta
          name="description"
          content="Zabali connects jewelry manufacturers and retailers directly. Discover premium collections, competitive pricing, and seamless wholesale jewelry buying."
        />

        <link rel="canonical" href="https://www.zabali.co/" />
        
      </Helmet>
      <div className="partners-screen-main-div">
        <div style={{ position: "sticky", top: 0 }}>
          <div className="section-1-div">
            <Header />
          </div>
        </div>
        <Section1
          onRetailerClick={onBecomeRetailer}
          onManufactureClick={onBecomeManufacture}
        />

        <Section2 partnersData={partnersData} />
        <Section3 benifitsMember={benifitsMember} />
        <Section4 />
        <Footer />
      </div>
    </>
  );
};

export default WelcomeScreen;
